const isMerck = (organizationName?: string) => (
  organizationName?.toLowerCase() === "merck"
);

export default isMerck;
